module.exports = __webpack_public_path__ + "static/img/footter_logo.ff8d8f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publick/footter_logo.png
// module id = /cRm
// module chunks = 29